export default __webpack_public_path__ + "static/media/cgu.702b623f.png";